import React, { useCallback } from 'react'
import { MenuItem, Select } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { SET_LOCALE } from '../../../features/State Management/localeSlice'
import useLocale from '../../../customHooks/useLocale'

const LocaleSelect = () => {
  const locale = useLocale()
  const dispatch = useDispatch()

  const localeChangeHandler = useCallback(
    (e) => {
      dispatch(SET_LOCALE({ locale: e.target.value }))
    },
    [dispatch]
  )

  return (
    <Select value={locale} onChange={localeChangeHandler}>
      <MenuItem value={'nl'}>nl</MenuItem>
      <MenuItem value={'en'}>en</MenuItem>
    </Select>
  )
}

export default LocaleSelect
